import React from 'react'
import FocusableButtonTS from '../FocusableButton/FocusableButtonTS'
import { KeyBoardDistributionEnum, KeyboardTogglerProps } from './types'
import {
  useFocusable,
  FocusableComponentLayout,
  FocusContext,
} from '@noriginmedia/norigin-spatial-navigation'
import tts from '../../lib/TTS'
import { setKeyboardDistributionTogglerProperties } from './utils'
import type { KeyTogglerProperties } from './types'

const PARENT_COMPONENT = 'KEYBOARD_TOGGLER_COMPONENT'

const KeyboardDistributionToggler = ({
  onEnterPress,
}: KeyboardTogglerProps) => {
  const { ref, focusKey } = useFocusable({
    focusKey: PARENT_COMPONENT,
  })

  const numericTogglerProperties = setKeyboardDistributionTogglerProperties(
    KeyBoardDistributionEnum.numeric
  )
  const alphaTogglerProperties = setKeyboardDistributionTogglerProperties(
    KeyBoardDistributionEnum.alpha
  )

  const handleOnFocus = (
    _: FocusableComponentLayout,
    props: { keyTogglerProperties: KeyTogglerProperties }
  ) => {
    const { keyTogglerProperties } = props
    tts.stop()
    tts.addTextToRead(`Focused on ${keyTogglerProperties.keyTTS}`)
  }

  const handleOnEnter = (props: {
    keyTogglerProperties: KeyTogglerProperties
  }) => {
    const { keyTogglerProperties } = props
    tts.stop()
    tts.addTextToRead(`Selected ${keyTogglerProperties.keyTTS}`)
    onEnterPress(keyTogglerProperties.keyToggler)
  }

  return (
    <FocusContext.Provider value={focusKey}>
      <div className="keyboard-toggler" ref={ref}>
        <div className="keyboard-toggler__alpha-numeric-toggle">
          <FocusableButtonTS
            className="keyboard-toggler__alpha-keyboard"
            onEnterPress={handleOnEnter}
            focusKey={KeyBoardDistributionEnum.alpha}
            onFocus={handleOnFocus}
            onArrowPress={(direction) => (direction === 'left' ? false : true)}
            extraProps={{ keyTogglerProperties: alphaTogglerProperties }}
          >
            {alphaTogglerProperties.keyLabel}
          </FocusableButtonTS>
          <FocusableButtonTS
            className="keyboard-toggler__numeric-keyboard"
            onEnterPress={handleOnEnter}
            focusKey={KeyBoardDistributionEnum.numeric}
            onFocus={handleOnFocus}
            extraProps={{ keyTogglerProperties: numericTogglerProperties }}
          >
            {numericTogglerProperties.keyLabel}
          </FocusableButtonTS>
        </div>
      </div>
    </FocusContext.Provider>
  )
}

export default KeyboardDistributionToggler
